module.exports = __webpack_public_path__ + "img/jiaohao.71ff6335.png";